import { render, staticRenderFns } from "./lghead.vue?vue&type=template&id=f889dc2a&"
import script from "./lghead.vue?vue&type=script&lang=js&"
export * from "./lghead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f889dc2a', component.options)
    } else {
      api.reload('f889dc2a', component.options)
    }
    module.hot.accept("./lghead.vue?vue&type=template&id=f889dc2a&", function () {
      api.rerender('f889dc2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/lghead.vue"
export default component.exports